module.exports = __webpack_public_path__ + "static/media/d22kz.6da493f7.pdf";